<script>
  import {
    SavingInterestRateNumber,
    SavingPremiumInterstRateNumber,
    AllDepositNumber
  } from "../utility/constant";
  let {
    result = {
      saving: {
        premium : {
          interest: SavingPremiumInterstRateNumber,
          interestTaxMinus: 0,
        },
        notPremium : {
          interest: SavingInterestRateNumber,
          interestTaxMinus: 0,
        }
      },
      deposit: {
        interest: AllDepositNumber,
        interestTaxMinus: 0,
      }
    }
  } = $props()

function formatCurrency(value) {
    if (value === null || isNaN(value)) return 'N/A';
    return Math.floor(value).toLocaleString();
  }

  // 小数点以下1桁まで表示
  function formatInterestRate(value) {
    if (value === null || isNaN(value)) return 'N/A';
    // toFixed() は文字列を返すため注意
    return value.toFixed(1);
  }
</script>

<div class="rates-head">
<p class="owd-text:01"><strong>シミュレーション結果</strong></p>
</div>
<div class="owd-wrap:overflow spacing:bottom:24">
  <div class="owd-table owd-table:scroll spacing:bottom:24">
    <table class="rates-table" style="min-width: 548px;">
      <tbody>
        <tr>
          <th style="width: calc((104/548)*100%);"></th>
          <th colspan="2" style="width: calc((297/548)*100%);"><strong>貯蓄預金</strong></th>
          <th style="width: calc((149/548)*100%);"><strong>普通預金</strong></th>
        </tr>
        <tr>
          <th></th>
          <th class="owd-sf:accent"><strong>プレミアム会員</strong></th>
          <th class="owd-sf:accent"><span style="line-height: 1.3;"><strong>プレミアム会員<br>以外の方</strong></span></th>
          <th class="owd-sf:accent"><strong>すべての方</strong></th>
        </tr>
        <tr>
          <th><strong>預金金利</strong></th>
          <td class="owd-sf:lightyellow"><strong>{formatInterestRate(result.saving.premium.interest)}%</strong></td>
          <td class="owd-sf:lightyellow"><strong>{formatInterestRate(result.saving.notPremium.interest)}%</strong></td>
          <td class="owd-sf:lightyellow"><strong>{formatInterestRate(result.deposit.interest)}%</strong></td>
        </tr>
        <tr>
          <th><strong>利息の概算額<br>（税引後）</strong></th>
          <td>{formatCurrency(result.saving.premium.interestTaxMinus)}円</td>
          <td>{formatCurrency(result.saving.notPremium.interestTaxMinus)}円</td>
          <td>{formatCurrency(result.deposit.interestTaxMinus)}円</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

  <ul class="owd-list:annotation spacing:bottom:16">
    <li>上記のシミュレーション結果は概算であり、実際の取引結果と異なる場合があります。預入金額や預入期間の目安として利用してください。</li>
    <li>預入金額を預入期間減額せずに預入いただいた場合のシミュレーションです。</li>
    <li>実際の利息の支払いは、毎日の最終残高1,000円以上について付利単位を1円とし、2月と8月の第3日曜日の翌営業日に計算して預金に組み入れる方法で行います。</li>
    <li>計算例：下記算式は、概算額を算出するための簡易的なものです。<br>1ヶ月：預入金額×金利×（1−20.315%）÷12<br>
      6ヶ月：預入金額×金利×（1−20.315%）÷2<br>1年：預入金額 ×金利×（1−20.315%）</li>
    <li>上記の計算例では、税率を国税と地方税を合計して簡易計算しています。実際の計算時には元金にそれぞれの税率を乗じて円未満を切り捨てのうえ、税引前利息から差し引いて計算します。</li>
    <li>利息には復興特別所得税を付加した20.315％の税金がかかります。</li>
  </ul>


<style lang="scss">

    .rates {
      &-head {
        background:var(--primary-black);
        color: var(--primary-white);;
        padding: 13px 24px;
        text-align: left;
        width: 100vw;
      }
    }
    .owd-table-sticky\:left{
      tbody{
        th{
          &:first-child{
            background-color: var(--gray-v3);
          }
        }
      }
    }
    // .rates-table *:not(.rates-head) {
    //   font-size: 12px;
    // }

    // .scroll-a::-webkit-scrollbar {
    //   width: 0;
    //   height: 4px;
    // }

    // .scroll-a::-webkit-scrollbar-thumb {
    //   background: rgba(0,0,0,.3); /* ハンドルの色 */
    // }

    // .scroll-a::-webkit-scrollbar-track {
    //   background: transparent; /* 背景色 */
    // }
</style>
